import { InfoBox } from './index';

type Props = {
    errors: object | [];
    locale: object; // deprecated
};

const ErrorBox = (props: Props) => (
    <InfoBox messages={props.errors} locale={props.locale} type="error" />
);

export default ErrorBox;
